export const pluralize = (number:number, one:string, few:string, many:string) => {
  const n = Math.abs(number);
  const forms = [one, few, many];

  if (n % 10 === 1 && n % 100 !== 11) {
    return forms[0];
  } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    return forms[1];
  } else {
    return forms[2];
  }
}